import { axiosPrivate } from "./axios";

/**
 * Meeting Notes API
 */

export const meetingNoteService = {
  /**
   * Get all employees (for permission selection)
   */
  getEmployees: async () => {
    const response = await axiosPrivate.get("/api/meeting-notes/employees");
    return response.data;
  },

  /**
   * Get all meeting notes accessible by the user
   */
  getMeetingNotes: async () => {
    const response = await axiosPrivate.get("/api/meeting-notes");
    return response.data;
  },

  /**
   * Get meeting note by ID.
   * Optionally pass a shareToken to access a note via a shared link.
   */
  getMeetingNoteById: async (id, shareToken) => {
    const params = shareToken ? { shareToken } : {};
    const response = await axiosPrivate.get(`/api/meeting-notes/${id}`, {
      params,
    });
    return response.data;
  },

  /**
   * Create a new meeting note
   */
  createMeetingNote: async (meetingNoteData) => {
    const response = await axiosPrivate.post(
      "/api/meeting-notes",
      meetingNoteData,
    );
    return response.data;
  },

  /**
   * Update meeting note.
   * Optionally pass a shareToken when the caller only has token-based edit access.
   */
  updateMeetingNote: async (id, updateData, shareToken) => {
    const params = shareToken ? { shareToken } : {};
    const response = await axiosPrivate.put(
      `/api/meeting-notes/${id}`,
      updateData,
      { params },
    );
    return response.data;
  },

  /**
   * Auto-save tab content.
   * Optionally pass a shareToken for token-based edit access.
   */
  autoSaveTabContent: async (id, tabIndex, content, shareToken) => {
    const params = shareToken ? { shareToken } : {};
    const response = await axiosPrivate.patch(
      `/api/meeting-notes/${id}/tabs/${tabIndex}`,
      { content },
      { params },
    );
    return response.data;
  },

  /**
   * Delete meeting note
   */
  deleteMeetingNote: async (id) => {
    const response = await axiosPrivate.delete(`/api/meeting-notes/${id}`);
    return response.data;
  },

  // ─── Share Link API ────────────────────────────────────────────────────────

  /**
   * Get all share links for a note
   */
  getShareLinks: async (id) => {
    const response = await axiosPrivate.get(`/api/meeting-notes/${id}/share`);
    return response.data;
  },

  /**
   * Generate a new share link
   * @param {string} id - note ID
   * @param {'view'|'edit'} permission
   */
  generateShareLink: async (id, permission) => {
    const response = await axiosPrivate.post(`/api/meeting-notes/${id}/share`, {
      permission,
    });
    return response.data;
  },

  /**
   * Update the permission level of an existing share link
   * @param {string} id - note ID
   * @param {string} token
   * @param {'view'|'edit'} permission
   */
  updateShareLinkPermission: async (id, token, permission) => {
    const response = await axiosPrivate.patch(
      `/api/meeting-notes/${id}/share/${token}`,
      { permission },
    );
    return response.data;
  },

  /**
   * Revoke (delete) a share link
   */
  revokeShareLink: async (id, token) => {
    const response = await axiosPrivate.delete(
      `/api/meeting-notes/${id}/share/${token}`,
    );
    return response.data;
  },
};
